import type { SvgIconProps } from '@mui/material';
import { Switch } from '@mui/material';
import {
  ListItem,
  ListItemButton,
  ListItemCard,
  ListItemContent,
  ListItemEndContent,
  ListItemIcon,
  ListItemPrimaryText,
  ListItemStartContent,
} from '../lists/ListItem';

export type PpMenuItemSwitch = {
  checked: boolean;
  dataQa?: string;
  disabled?: boolean;
  icon: React.FC<SvgIconProps>;
  label: string;
  onClick: () => void;
};

export function MenuItemSwitch({
  checked,
  dataQa,
  disabled,
  icon: Icon,
  label,
  onClick,
}: PpMenuItemSwitch): React.ReactElement {
  return (
    <ListItem data-qa={dataQa}>
      <ListItemButton disabled={disabled} onClick={onClick}>
        <ListItemCard withHoverEffect>
          <ListItemContent>
            <ListItemIcon>
              <Icon />
            </ListItemIcon>
            <ListItemStartContent>
              <ListItemPrimaryText>{label}</ListItemPrimaryText>
            </ListItemStartContent>
            <ListItemEndContent>
              <Switch aria-checked={checked} checked={checked} />
            </ListItemEndContent>
          </ListItemContent>
        </ListItemCard>
      </ListItemButton>
    </ListItem>
  );
}
